import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    overflow: "auto",
    cursor: "grab",
    height: 700,
    background: theme.palette.background.paper,
    boxShadow: theme?.shadows ? theme.shadows[1] : "0 1px 3px rgba(0,0,0,0.1)",
    borderRadius: 8,
    border: `1px solid ${theme.palette.utility.utility_gray_200}`,
    position: "relative",
    whiteSpace: "nowrap",
    margin: "0 auto",
  },
  tableHeadCell: {
    fontWeight: 500,
    fontSize: "14px",
    minWidth: "240px",
    height: "44px",
    padding: "0",
    color: theme.palette.text.tertiary,
    background: theme.palette.background.gray_50, // Light gray background,
  },
  firstCell: {
    background: theme.palette.background.gray_50, // Light gray background,
  },
  tableCell: {
    padding: "16px 0",
    fontSize: "14px",
    fontWeight: 500,
    "& label": {
      width: "90%",
      whiteSpace: "normal",
      paddingRight: "10px",
    },
  },
  expandIcon: {
    padding: 4,
  },
  detailTable: {
    width: "auto",
    background: "#fafafa",
    position: "relative !important",
  },
  activeRow: {
    background: theme?.palette?.action?.selected || "#e3f2fd",
  },
  detailTableCell: {
    background: theme.palette.background.gray_50,
  },
  noDataWrapper: {
    position: "absolute",
    width: "500px",
    left: "0",
    transform: "translate(85%)",
    transformOrigin: "center",
  },
}));

export default useStyles;
